<div class="date-range">
  <label class="date-range__label">{{ label }}</label>

  <div class="date-range__trigger-wrapper">
    <button
      type="button"
      class="date-range__trigger"
      [class.date-range__trigger--active]="isOpen"
      [class.date-range__trigger--filled]="hasValue"
      (click)="togglePicker()"
    >
      <i class="fa-regular fa-calendar"></i>
      <span class="date-range__text">{{ formatDateRange() }}</span>
      <i
        class="fa-solid fa-chevron-down date-range__chevron"
        [class.date-range__chevron--open]="isOpen"
      ></i>
    </button>

    <button
      *ngIf="hasValue"
      type="button"
      class="date-range__clear"
      (click)="clear($event)"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="date-range__dropdown" *ngIf="isOpen">
    <div class="date-range__quick-filters">
      <button type="button" class="date-range__quick-btn" (click)="setToday()">
        Hoy
      </button>
      <button
        type="button"
        class="date-range__quick-btn"
        (click)="setThisWeek()"
      >
        Semana
      </button>
      <button
        type="button"
        class="date-range__quick-btn"
        (click)="setThisMonth()"
      >
        Mes
      </button>
      <button
        type="button"
        class="date-range__quick-btn"
        (click)="setLastMonth()"
      >
        Mes anterior
      </button>
    </div>

    <div class="date-range__divider"></div>

    <div class="date-range__calendar">
      <ngb-datepicker
        #dp
        [displayMonths]="1"
        [dayTemplate]="dayTemplate"
        [startDate]="fromDate!"
        outsideDays="visible"
        navigation="arrows"
        (dateSelect)="onDateSelection($event)"
      ></ngb-datepicker>

      <ng-template
        #dayTemplate
        let-date
        let-focused="focused"
        let-currentMonth="currentMonth"
      >
        <span
          class="date-range__day"
          [class.focused]="focused"
          [class.range]="isRange(date)"
          [class.faded]="isHovered(date) || isInside(date)"
          [class.outside]="date.month !== currentMonth"
          [class.disabled]="date.month !== currentMonth"
          (mouseenter)="hoveredDate = date"
          (mouseleave)="hoveredDate = null"
        >
          {{ date.day }}
        </span>
      </ng-template>
    </div>

    <div class="date-range__selected" *ngIf="fromDate">
      <span class="date-range__selected-label">Seleccionado:</span>
      <span class="date-range__selected-value">{{ formatDateRange() }}</span>
    </div>
  </div>
</div>
